export const undefinedFilterMutator =
  (next = (x: any) => x) =>
  (params: Record<string, unknown>) => {
    const filteredParams = Object.assign({}, params)
    Object.keys(filteredParams).forEach(
      key => filteredParams[key] === undefined && delete filteredParams[key],
    )

    return next(filteredParams)
  }

export const objectFilterMutator =
  (next = (x: any) => x) =>
  (params: Record<string, unknown>) => {
    const filteredParams: Record<string, unknown> = {}
    Object.keys(params).forEach(
      key =>
        (filteredParams[key] =
          typeof params[key] === 'object'
            ? JSON.stringify(params[key])
            : params[key]),
    )

    return next(filteredParams)
  }
